import React, { useEffect } from 'react';
import styles from './Poll.styles';

const Poll = ({ diagram }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.defer = true;
    script.src = '//widgets.opinary.com/embed.js';
    document.querySelector('.poll-container').appendChild(script);
  });

  return (
    <div css={styles}>
      <div className="poll-container" dangerouslySetInnerHTML={{ __html: diagram }} />
    </div>
  );
};

export default Poll;
